export const isActive = (status: boolean): string =>
  status ? "Active" : "Inactive";

export const lowercaseActive = (status: boolean): "active" | "inactive" =>
  status ? "active" : "inactive";
